var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgA2ElectricalConnection(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 9v58h58V9H9zm54 54H40V51.61a4 4 0 00-2.8-7.36l-9.47-9.47-2.83 2.82 9.32 9.32A3.9 3.9 0 0036 51.61V63H13V13h23v12.39a4 4 0 104 0V13h23v50z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/A2_Electrical_Connection.6791aadd.svg";
export { SvgA2ElectricalConnection as ReactComponent };